// extracted by mini-css-extract-plugin
export default {"versionContainer":"AppVersion_versionContainer__E-mG4"};